// extracted by mini-css-extract-plugin
export default {"countdown":"CountdownTimer_countdown__vXfC7","pulse":"CountdownTimer_pulse__F1lz-"};